module.exports = __webpack_public_path__ + "static/media/MaskGroup.9f1b9c65.png";